import { render, staticRenderFns } from "./queryStatistics.vue?vue&type=template&id=53293872&scoped=true&"
import script from "./queryStatistics.vue?vue&type=script&lang=ts&"
export * from "./queryStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./queryStatistics.vue?vue&type=style&index=0&id=53293872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53293872",
  null
  
)

export default component.exports